import script from "./VerificationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VerificationModal.vue?vue&type=script&setup=true&lang=js"

import "./VerificationModal.vue?vue&type=style&index=0&id=3347317a&lang=scss"

const __exports__ = script;

export default __exports__